export enum PhonePreviewTheme {
  TIKTOK = 'TikTok',
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  WHATSAPP = 'WhatsApp',
}

export type PhonePreviewThemeType = `${PhonePreviewTheme}`
